import React from 'react';
import { LAST_UPDATED_DATE, LEGAL_TODOS } from './legalPlaceholders';

const LegalNotice = () => (
  <main className="legal-page">
    <h1>Legal Notice</h1>
    <p>
      <strong>Last updated:</strong> {LAST_UPDATED_DATE}
    </p>
    <p>
      This Legal Notice governs access to and use of the website https://www.101setups.com and any related pages,
      content, features, and services made available through 101Setups.
    </p>

    <h2>Operator information</h2>
    <p>
      The website is operated from Spain by {LEGAL_TODOS.operatorName} (&quot;101Setups&quot;, &quot;we&quot;, &quot;us&quot;,
      or &quot;our&quot;).
    </p>
    <ul>
      <li>
        <strong>Postal address for legal notices:</strong> {LEGAL_TODOS.postalAddress}
      </li>
      <li>
        <strong>Email:</strong> {LEGAL_TODOS.legalContactEmail}
      </li>
      <li>
        <strong>Tax ID / NIF / VAT:</strong> {LEGAL_TODOS.taxId}
      </li>
      <li>
        <strong>Domain:</strong> 101setups.com
      </li>
    </ul>

    <h2>Nature of the website</h2>
    <p>
      101Setups is an editorial and discovery platform focused on desk setups, workspaces, and related products. We
      may publish our own content and may also host user-submitted setup content, images, tags, descriptions, and
      related materials.
    </p>
    <p>
      Some links on 101Setups are affiliate links, including Amazon links. If you buy through those links, 101Setups
      may earn a commission at no extra cost to you. Where a tagged product link opens an Amazon search page or similar
      discovery page, it is intended to help you find the relevant item or similar items; it should not be understood
      as a guarantee that the destination is the exact product shown unless we expressly say so.
    </p>

    <h2>Use of the website</h2>
    <p>
      You agree to use 101Setups lawfully, in good faith, and without infringing the rights of other people or
      interfering with the normal operation of the website. You must not use the site to upload, publish, transmit, or
      link to unlawful, defamatory, infringing, deceptive, abusive, hateful, or malicious content, or to introduce
      malware, automated scraping abuse, or other harmful code or behaviour.
    </p>

    <h2>User-submitted content</h2>
    <p>
      If you submit content to 101Setups, you remain responsible for that content and for ensuring that you have all
      rights, permissions, and consents necessary to submit it and make it available through the service. You must not
      submit content that infringes copyright, trade marks, image rights, privacy rights, or other third-party rights.
    </p>

    <h2>Intellectual property</h2>
    <p>
      Unless otherwise stated, the website design, branding, compilation, and original content created by 101Setups are
      protected by intellectual property rights owned by or licensed to the operator. You may not reproduce,
      distribute, modify, publicly communicate, or exploit protected content from the site except as permitted by law
      or with prior written permission.
    </p>

    <h2>Third-party websites and services</h2>
    <p>
      101Setups may contain links to third-party websites, platforms, and services, including Amazon and social
      networks. We are not responsible for the content, availability, policies, or practices of those third parties.
      Your use of third-party services is governed by their own terms and privacy policies.
    </p>

    <h2>Disclaimer</h2>
    <p>
      101Setups is provided on an &quot;as is&quot; and &quot;as available&quot; basis. We try to keep the information on the site
      accurate and useful, but we do not guarantee uninterrupted availability, the absence of errors, the availability
      of any third-party product, or the accuracy of third-party descriptions, prices, reviews, or stock information.
      Content on 101Setups is provided for general information and inspiration only and does not constitute
      professional, technical, ergonomic, medical, legal, tax, or purchasing advice.
    </p>
    <p>Nothing in this Legal Notice excludes or limits liability where such exclusion or limitation is not permitted under applicable law.</p>

    <h2>Reporting notices and complaints</h2>
    <p>
      If you believe that content on 101Setups is unlawful, infringes your rights, or should be removed, please contact
      us at {LEGAL_TODOS.legalContactEmail} with enough detail for us to review the request.
    </p>

    <h2>Applicable law and jurisdiction</h2>
    <p>
      This Legal Notice is governed by Spanish law. Unless mandatory consumer or other applicable law provides
      otherwise, any dispute relating to 101Setups shall be submitted to the courts of {LEGAL_TODOS.jurisdictionCity},
      Spain.
    </p>
  </main>
);

export default LegalNotice;
